// Wishlist — localStorage list of product IDs. Toggle from anywhere
// with [data-wishlist-toggle="<id>"]; the header badge listens for
// `haegoziya:wishlist-changed` and re-renders the count. The /wishlist/
// page hydrates from the same key — see renderWishlistPage() below.

const KEY = 'haegoziya_wishlist';

function load() {
    try {
        const raw = localStorage.getItem(KEY);
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr.filter(n => Number.isFinite(n)) : [];
    } catch (e) {
        return [];
    }
}

function save(ids) {
    localStorage.setItem(KEY, JSON.stringify(ids));
    document.dispatchEvent(new CustomEvent('haegoziya:wishlist-changed', { detail: { ids } }));
}

function toggle(id) {
    id = parseInt(id, 10);
    if (!id) return { action: 'noop' };
    const ids = load();
    const idx = ids.indexOf(id);
    if (idx >= 0) {
        ids.splice(idx, 1);
        save(ids);
        return { action: 'removed', count: ids.length };
    }
    ids.push(id);
    save(ids);
    return { action: 'added', count: ids.length };
}

function paintBadge() {
    const n = load().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = String(n); });
}

function paintToggles() {
    const ids = new Set(load());
    document.querySelectorAll('[data-wishlist-toggle]').forEach(el => {
        const id = parseInt(el.getAttribute('data-wishlist-toggle'), 10);
        if (!id) return;
        el.classList.toggle('is-saved', ids.has(id));
        el.setAttribute('aria-pressed', ids.has(id) ? 'true' : 'false');
    });
}

// ── Toast feedback ──────────────────────────────────────────────
let toastEl;
function showToast(msg, variant = 'ok') {
    if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'wishlist-toast';
        document.body.appendChild(toastEl);
    }
    toastEl.dataset.variant = variant;
    toastEl.innerHTML = `
        <span class="wishlist-toast__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 21s-7-4.5-9.5-9C.7 8.2 3 4 7 4c1.8 0 3.4 1 5 3 1.6-2 3.2-3 5-3 4 0 6.3 4.2 4.5 8-2.5 4.5-9.5 9-9.5 9z"/></svg>
        </span>
        <span class="wishlist-toast__msg">${msg}</span>
        <a class="wishlist-toast__cta" href="/wishlist/">View list →</a>
    `;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 3200);
}

// ── /wishlist/ page renderer ────────────────────────────────────
//   PHP emits a <template data-wishlist-product="ID"> per product.
//   Read the saved IDs, clone the matching templates into the grid.
function renderWishlistPage() {
    const empty   = document.querySelector('[data-wishlist-empty]');
    const grid    = document.querySelector('[data-wishlist-grid]');
    const summary = document.querySelector('[data-wishlist-summary]');
    const countT  = document.querySelector('[data-wishlist-count-text]');
    if (!grid || !empty) return;                  // not on the wishlist page

    const ids = load();
    if (!ids.length) {
        empty.hidden = false;
        grid.hidden  = true;
        if (summary) summary.hidden = true;
        grid.innerHTML = '';
        return;
    }

    empty.hidden = true;
    grid.hidden  = false;
    if (summary) { summary.hidden = false; }
    if (countT)  { countT.textContent = String(ids.length); }

    grid.innerHTML = '';
    ids.forEach(id => {
        const tpl = document.querySelector(`template[data-wishlist-product="${id}"]`);
        if (!tpl) return;
        grid.appendChild(tpl.content.cloneNode(true));
    });
}

// ── Click delegation ────────────────────────────────────────────
document.addEventListener('click', e => {
    const target = e.target.closest('[data-wishlist-toggle]');
    if (!target) return;
    e.preventDefault();
    const id = target.getAttribute('data-wishlist-toggle');
    const r = toggle(id);
    if (r.action === 'added')   showToast(`Saved to wish list (${r.count})`);
    if (r.action === 'removed') showToast('Removed from wish list');
});

document.addEventListener('haegoziya:wishlist-changed', () => {
    paintBadge();
    paintToggles();
    renderWishlistPage();
});

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        paintBadge();
        paintToggles();
        renderWishlistPage();
    });
} else {
    paintBadge();
    paintToggles();
    renderWishlistPage();
}
